/**
 * Error message component.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';

export interface ChatErrorMessageProps {
  error: string | null;
}

export const ChatErrorMessage: React.FC<ChatErrorMessageProps> = ({ error }) => {
  if (!error) {
    return null;
  }

  return (
    <Box
      sx={{
        p: 1,
        bgcolor: 'white',
        color: 'error.main',
        borderRadius: 1,
      }}
    >
      <Typography variant="par01Regular" sx={{ color: 'error.main' }}>
        {error}
      </Typography>
    </Box>
  );
};

